import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../../global';
import {
  AddRemoveCriteriaGroupData,
  CreateCriteriasGroupData,
  DefaultCriteriasParams,
  DetailProps,
  GetDefaultCriteriasResponse,
  GetTypologiesAndCriteriasResponse,
  NewCriteriaData,
  RemoveCriteriaGroupData,
  UpdateCriteriaGroupData,
} from './types';

export const getNoticeTypologiesAndCriterias = (
  noticeId: number
): Promise<GetTypologiesAndCriteriasResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getDefaultCriterias = (
  params: DefaultCriteriasParams
): Promise<GetDefaultCriteriasResponse> => {
  const { activity, noticeId } = params;
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithToken(),
  };

  const queries = new URLSearchParams({});
  if (activity) queries.append('activity', activity);
  if (noticeId) queries.append('notice_id', noticeId.toString());

  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/criterias/default?${queries.toString()}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const createNewCriteria = (
  data: NewCriteriaData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/criterias/default`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const createCriteriasGroup = (
  noticeId: number,
  data: CreateCriteriasGroupData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const updateCriteriaGroup = (
  noticeId: number,
  criteriaGroupId: number,
  data: UpdateCriteriaGroupData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups/${criteriaGroupId}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const addToCriteriaGroup = (
  noticeId: number,
  criteriaGroupId: number,
  data: AddRemoveCriteriaGroupData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups/${criteriaGroupId}/add`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const removeFromCriteriaGroup = (
  noticeId: number,
  criteriaGroupId: number,
  data: AddRemoveCriteriaGroupData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups/${criteriaGroupId}/remove`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const deleteCriteriasGroup = ({
  noticeId,
  criteriaGroupId,
}: RemoveCriteriaGroupData): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${noticeId}/criteria-groups/${criteriaGroupId}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
